import { notFound } from 'next/navigation';

import type { IProduct, IProductOptions } from '@/entities/product/types';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilFetch } from '@/lib/utils';

import { filterProduct } from '../libs/filter';

const apiGetProduct = async ({ idx, lng }: IProductOptions): Promise<IProduct> => {
  try {
    const response = await utilFetch(lng)(`${NEXT_PUBLIC_API_URL}/api/products/${idx}`, {
      method: 'GET',
    });

    // 서버에서 오류 페이지(HTML) 반환 또는 상태 코드 오류 시 404로 이동
    if (!response.ok) {
      notFound();
    }

    const result = await response.json();

    if (!result?.ok) {
      notFound();
    }

    return filterProduct(result.data);
  } catch {
    // JSON 파싱 오류 등 예외 발생 시 404로 이동
    notFound();
  }
};

export default apiGetProduct;
